var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellframeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6030_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 6C46.3344 6 6 46.4849 6 96C6 145.666 46.3344 186 96 186C145.666 186 186 145.666 186 96C185.849 46.4849 145.515 6 96 6ZM96 15.0302C134.829 15.0302 167.187 42.7225 175.013 78.9934H131.067C128.809 78.9934 127.003 80.6489 126.552 82.9064L117.672 132.572L96.7525 39.2609C96.301 37.1539 94.495 35.6489 92.388 35.6489C90.2809 35.6489 88.3244 37.0034 87.8729 39.1104L68.0067 113.458L59.7291 82.4549C59.1271 80.4984 57.3211 78.8429 55.214 78.8429H16.9866C24.6622 42.7225 57.1706 15.0302 96 15.0302ZM15.1806 96.1506C15.1806 140.699 51.4515 176.819 96 176.819C140.398 176.819 176.669 140.699 176.669 96.1506C176.669 93.5921 176.669 90.883 176.368 88.776H134.98L123.09 155.9C122.639 158.157 120.833 159.512 118.575 159.512C116.318 159.512 114.512 158.007 114.06 155.9L91.6354 60.4817L72.5217 132.572C71.9197 134.529 70.1137 136.034 68.0067 136.034C65.8997 136.034 64.0936 134.679 63.4916 132.722L51.7525 88.776H15.4816C15.3311 90.7325 15.1806 93.5921 15.1806 96.1506Z",
    fill: "#224D5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6030_501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellframeIcon);
export default __webpack_public_path__ + "static/media/wellframeIcon.f24d8cd40ee16cb9cb188079c0e8ef93.svg";
export { ForwardRef as ReactComponent };